import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Button,
  Select,
  MenuItem,
  FormControl,
  Grid2,
  FormLabel,
  TextField,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useGlobalModalContext } from "../../context/GlobalModalContext";
import MeetingMinuteDialog from "./MeetingMinuteDialog";
import { fileUploadaxiosInstance } from "../../utils/axios";
import { useState } from "react";
import { useLoading } from "../../context/LoadingContext";

const GenerateMeetingMinuteDialog = () => {
  const { showModal, hideAllModal, hideModal } = useGlobalModalContext();
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [file, setFile] = useState("");
  const [fileError, setFileError] = useState(false);
  const { showLoading, hideLoading } = useLoading();

  const handleSubmit = async (e) => {
    showLoading();
    try {
      e.preventDefault();
      setFileError(false);
      if (!file) {
        setFileError(true);
        return;
      }
      const response = await fileUploadaxiosInstance.post("/MOM/generate", {
        language: selectedLanguage,
        file: file,
      });

      console.log(response, "rrrrr");
      if (response.data) {
        hideModal();
        showModal(<MeetingMinuteDialog data={response.data} />);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      hideLoading();
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFile(file);
      setFileError(false);
      console.log("Selected file:", file);
    }
  };

  return (
    <Dialog open onClose={hideModal} maxWidth={"md"} fullWidth={true}>
      <DialogTitle>
        <h4 className="font-bold text-center">Meeting Minutes Generator</h4>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={hideModal}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseOutlined />
      </IconButton>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Grid2 container direction={"row"} rowGap={2}>
            <FormControl fullWidth size="small" required>
              <FormLabel>Select Language</FormLabel>
              <Select
                size="small"
                value={selectedLanguage}
                onChange={(e) => {
                  setSelectedLanguage(e.target.value);
                }}
              >
                <MenuItem value={"Bahasa"}>Bahasa</MenuItem>
                <MenuItem value={"English"}>English</MenuItem>
              </Select>
            </FormControl>
            <FormControl size="small" required error={fileError}>
              <input
                type="file"
                accept=".txt, .wav, .mp3"
                onChange={handleFileChange}
                style={{ display: "none" }}
                id="file-input"
              />
              <FormLabel htmlFor="file-input">
                Upload MP3, WAV or TXT File
              </FormLabel>
              <Grid2>
                <label htmlFor="file-input">
                  <Button variant="outlined" component="span">
                    Upload File
                  </Button>
                  {file && (
                    <span className="ml-2 text-sm">
                      Selected File: {file.name}
                    </span>
                  )}
                </label>
              </Grid2>
            </FormControl>
          </Grid2>
          <Grid2 my={2}>
            <Button
              type="submit"
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
            >
              Generate Minutes of Meeting
            </Button>
          </Grid2>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default GenerateMeetingMinuteDialog;
